<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="12" cols="12">
                    <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                    <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb/>
                    </nav>
                </b-col>
            </b-row>
      </base-header>
        <b-container fluid class="mt--6">
            <b-row>
                <b-col cols="12">
                    <b-card>
                        <div slot="header" class="mb-0">
                            <b-row>
                                <b-col cols="10">
                                    <h3>{{title}}</h3>
                                </b-col>
                                <b-col cols="2">
                                    <h4 class="float-right">
                                        <span v-if="stocktransfer.status == 'PENDING'" class="text-warning">
                                            <i class="fa fa-clock-o mr-2"></i>{{language_terms[stocktransfer.status]}}
                                        </span>
                                        <span v-if="stocktransfer.status == 'PROVISIONING'" class="text-info">
                                            <i class="fas fa-lock mr-2"></i>{{language_terms[stocktransfer.status]}}
                                        </span>
                                        <span v-if="stocktransfer.status == 'SENT'" class="text-primary">
                                           <i class="fa fa-chevron-circle-right mr-2"></i>{{language_terms[stocktransfer.status]}}</span>
                                        <span v-if="stocktransfer.status == 'RECEIVED'" class="text-success">
                                            <i class="fa fa-check-circle mr-2"></i>{{language_terms[stocktransfer.status]}}
                                        </span>
                                        <span v-if="stocktransfer.status == 'CANCELLED'" class="text-warning">
                                            <i class="fa fa-ban mr-2"></i>{{language_terms[stocktransfer.status]}}
                                        </span>
                                    </h4>
                                </b-col>
                            </b-row>
                        </div>
                        <b-row>
                            <b-col cols="4">
                                <base-input :label="language_terms['DATE_REQUEST']" v-if="is_edit && !show_next_step">
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        style="background-color: white"
                                        class="form-control datepicker"
                                        v-model="stocktransfer.date_requested">
                                    </flat-picker>
                                </base-input>
                                <base-input  v-if="!is_edit || show_next_step"
                                :label="language_terms['DATE_REQUEST']"
                                v-model="stocktransfer.date_requested" type="date" disabled></base-input>
                            </b-col>
                            <b-col cols="4">
                                <label class="form-control-label">{{language_terms['FROM_LOCATION']}}</label>
                                    <multiselect
                                        :tag-placeholder="language_terms['FROM_LOCATION']"
                                        :placeholder="language_terms['SEARCH']"
                                        open-direction="bottom"
                                        label="code"
                                        track-by="code"
                                        :options="from_warehouses"
                                        text-field="name"
                                        :multiple="false"
                                        v-model="stocktransfer.from_location"
                                        :taggable="false"
                                        :disabled="show_next_step || !is_edit"
                                        @input="selectFromLocation"
                                    ></multiselect>
                                <!-- <locationLookup v-bind:url="apiLocationLookup" v-on:selected="selectFromLocation($event)" :lookupId="stocktransfer.from_location_code" :disabled="show_next_step || !is_edit"/> -->
                            </b-col>
                            <b-col cols="4">
                                <label class="form-control-label">{{language_terms['TO_LOCATION']}}</label>
                                    <multiselect
                                        :tag-placeholder="language_terms['TO_LOCATION']"
                                        :placeholder="language_terms['SEARCH']"
                                        open-direction="bottom"
                                        label="code"
                                        track-by="code"
                                        :options="to_warehouses"
                                        text-field="name"
                                        :multiple="false"
                                        v-model="stocktransfer.to_location"
                                        :taggable="false"
                                        :disabled="show_next_step || !is_edit"
                                        @input="selectToLocation"
                                    ></multiselect>
                                <!-- <locationLookup v-bind:url="apiLocationLookup" v-on:selected="selectToLocation($event)" :lookupId="stocktransfer.to_location_code" :disabled="show_next_step || !is_edit"/> -->
                            </b-col>
                            <b-col cols="12">
                                <base-input :label="language_terms['REMARKS']">
                                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="stocktransfer.remarks" :disabled="show_next_step || !is_edit">
                                    </textarea>
                                </base-input>
                            </b-col>
                            <b-col cols="12">
                                <b-button variant="success" @click="goNext" v-if="!show_next_step && is_edit">
                                  {{language_terms['NEXT']}}<i class="fa fa-arrow-right ml-2"></i>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <b-row v-if="!is_edit && !show_next_step">
                <b-col cols="12">
                    <div class="card-wrapper">
                        <b-card>
                            <div slot="header" class="mb-0">
                                <h3>{{ language_terms["TRANSFER_ITEMS"] }}</h3>
                            </div>
                            <b-row>
                                <b-col cols="12">
                                    <b-table-simple striped hover responsive>
                                    <b-thead head-variant="light">
                                        <tr>  
                                            <th>{{language_terms['SNO']}}</th>
                                            <th>{{language_terms['PRODUCT_CODE']}}</th>
                                            <th>{{language_terms['PRODUCT']}}</th>
                                            <th>{{language_terms['QTY_REQUESTED']}}</th>
                                            <th>{{language_terms['QTY_SENT']}}</th>
                                            <th>{{language_terms['QTY_RECEIVED']}}</th>
                                            <th v-if="is_edit_qty_received">{{language_terms['QTY_REJECTED']}}</th>
                                            <th v-if="is_edit_qty_received">{{language_terms['LOCATION']}}</th>
                                            <th v-if="is_edit_qty_received">{{language_terms['LOT_NUMBER']}}</th>
                                            <th v-if="is_edit_qty_received">{{language_terms['EXPIRY_DATE']}}</th>
                                            <th v-if="is_edit_qty_sent  || stocktransfer.allow_confirm_qty_sent"></th>
                                        </tr>
                                    </b-thead>
                                    <b-tbody v-for="(row, index) in stocktransfer.items" :key="index">
                                        <b-tr>
                                            <td width="20px">{{ index + 1 }}</td>
                                            <td>{{row.product_code}}</td>
                                            <td>{{row.product_name}}</td>
                                            <td>{{row.qty_requested}}</td>
                                            <td v-if="is_edit_qty_sent == false">{{row.qty_sent ? row.qty_sent: '-'}}</td>
                                            <td v-else>
                                                <base-input v-model="row.qty_sent" type="number" :max="row.qty_requested" @change="onChangeQtySent(row, index)"></base-input>
                                            </td>
                                            <td v-if="is_edit_qty_received == false">{{row.qty_received ? row.qty_received : '-'}}</td>
                                            <td v-else>
                                                <base-input v-model="row.qty_received" type="number" :max="row.qty_sent"></base-input>
                                            </td>
                                            <td v-if="is_edit_qty_received">
                                                <base-input v-model="row.qty_rejected" type="text" ></base-input>
                                            </td>
                                            <td v-if="is_edit_qty_received">
                                                <el-select v-model="row.location_id" filterable :placeholder="language_terms['LOCATIONS']" value-key="id" >
                                                    <el-option
                                                        v-for="option in row.locations"
                                                        :key="option.id"
                                                        :label="option.name"
                                                        :value ="option.id">
                                                    </el-option>
                                                </el-select>
                                            </td>
                                            <td v-if="is_edit_qty_received">
                                                <base-input v-model="row.lot_reference" type="text" :disabled="row.has_lot == '0'"></base-input>
                                            </td>
                                            <td v-if="is_edit_qty_received">
                                                <base-input v-if="row.expiry_mths">
                                                    <flat-picker
                                                        slot-scope="{ focus, blur }"
                                                        @on-open="focus"
                                                        @on-close="blur"
                                                        style="background-color: white"
                                                        class="form-control datepicker"
                                                        v-model="row.expiry_date">
                                                    </flat-picker>
                                                </base-input> 
                                                <base-input type="date"  v-model="row.expiry_date" v-else disabled/>                               
                                            </td>
                                            <td v-if="is_edit_qty_sent || stocktransfer.allow_confirm_qty_sent">
                                                <base-button @click="handleHide(index, row)" size="sm" icon type="success"><i class="fa fa-angle-down"></i></base-button>                                           
                                            </td>
                                        </b-tr>
                                        <b-tr v-if="row.is_collasped">
                                            <td colspan="7">
                                                <b-collapse v-model="row.is_collasped" class="mt-2">
                                                    <b-table-simple responsive>
                                                        <b-thead head-variant="light">
                                                                <b-th>{{language_terms['LOCATION']}}</b-th>
                                                                <b-th>{{language_terms['LOT_NUMBER']}}</b-th>
                                                                <b-th>{{language_terms['EXPIRY_DATE']}}</b-th>
                                                                <b-th>{{language_terms['QTY']}}</b-th>
                                                                <b-th>{{language_terms['ALLOCATE_QTY']}}</b-th>
                                                        </b-thead>
                                                        <b-tbody v-for="(lot, j) in row.locations" :key="j">
                                                            <td>{{lot.location_name}}</td>
                                                            <td>{{lot.lot_reference ? lot.lot_reference : '-'}}</td>
                                                            <td>{{lot.expiry_date ? lot.expiry_date : '-'}}</td>
                                                            <td>{{lot.qty}}</td>
                                                            <td>
                                                                <input v-model="lot.allocate_qty" type="number" class="form-control" :max="lot.qty" :disabled="stocktransfer.allow_confirm_qty_sent"/>
                                                            </td>
                                                        </b-tbody>
                                                    </b-table-simple>
                                                </b-collapse>
                                            </td>
                                        </b-tr>
                                    </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="show_next_step">
                <b-col cols="12">
                    <div class="card-wrapper">
                        <b-card>
                            <div slot="header" class="mb-0">
                                <b-row>
                                    <b-col cols="10">
                                        <h3>{{ language_terms["TRANSFER_ITEMS"] }} </h3>
                                    </b-col>
                                    <b-col cols ="2">
                                        <b-button variant="success" @click="goBack" v-if="show_next_step">
                                            <i class="fa fa-arrow-left mr-2"></i>{{language_terms['PREV']}}
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </div>
                            <b-row>
                                <b-col cols="12" v-if="is_edit">
                                    <b-col md="12" v-for="(item, index) in stocktransfer.items" :key="index">
                                        <b-card>
                                            <b-row>
                                                <!-- {{item}} -->
                                                <b-col cols="5">
                                                    <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                                                    <productLookup v-bind:url="apiProductLookup" v-on:selected="selectProduct($event, index)" :lookupId="item.product_code" :v2="stocktransfer.from_location_id"/>
                                                </b-col>
                                                <b-col cols="2">
                                                    <base-input :label="language_terms['PHYSICAL_QTY'] + ' (' + stocktransfer.from_location_code + ')'" v-model="item.from_location_available_qty" type="number" min="0" disabled></base-input>
                                                </b-col>
                                                <b-col cols="2">
                                                    <base-input :label="language_terms['PHYSICAL_QTY'] + ' (' + stocktransfer.to_location_code + ')'" v-model="item.to_location_available_qty" type="number" min="0" disabled></base-input>
                                                </b-col>
                                                <b-col cols="2">
                                                    <base-input :label="language_terms['QTY']" v-model="item.qty_requested" type="number" :max="item.from_location_available_qty" :disabled="!is_edit"></base-input>
                                                </b-col>
                                                <b-col lg="1" class="mt-4 float-right">
                                                    <base-button @click="handleDelete(index)" size="sm" icon type="danger" class="mt-3"><i class="fas fa-trash-alt"></i ></base-button>
                                                    <base-button @click="handleCollaspe(index, item)" size="sm" icon type="success" class="mt-3"><i class="fa fa-angle-down"></i></base-button>
                                                </b-col>
                                            </b-row>
                                            <b-collapse v-model="item.is_collasped">
                                                <b-row>
                                                    <b-col cols="12">
                                                        <base-input :placeholder="item.name" v-model="item.product_remarks" type="text" :disabled="!is_edit" :label="language_terms['PRODUCT_REMARKS']"></base-input>
                                                    </b-col>
                                                </b-row>
                                            </b-collapse>
                                        </b-card>
                                    </b-col>
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <div class="floating-bar">
            <div class="floating-bar-container" align="center">
                <b-button-group>
                    <b-button class="transparent-btn" @click="addItems" v-if="(show_next_step && is_edit)">
                        <i class="fas fa-plus mr-2 text-warning"></i>{{language_terms['ADD']}}
                    </b-button>
                    <b-button class="transparent-btn" @click="editDocument"  v-if="(is_edit == 0 && (stocktransfer.allow_edit_all || stocktransfer.allow_edit_qty_received) && (!is_edit_qty_sent && !is_edit_qty_received))">
                        <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                    </b-button>
                    <b-button class="transparent-btn" @click="provisionDocument"  v-if="(is_edit == 0 && stocktransfer.allow_provisioning && !is_edit_qty_sent)">
                        <i class="fas fa-check mr-2 text-success"></i>{{language_terms['PROVISIONING']}}
                    </b-button>
                    <b-button class="transparent-btn" @click="confirmSent" v-if="stocktransfer.allow_confirm_qty_sent">
                        <i class="fas fa-check-double mr-2 text-success"></i>{{language_terms['CONFIRM_SENT']}} 
                    </b-button>  
                    <b-button class="transparent-btn" @click="cancelTransfer" v-if="stocktransfer.allow_cancel">
                        <i class="fa fa-ban mr-2 text-warning"></i>{{language_terms['CANCEL']}} 
                    </b-button>       
                    <b-button class="transparent-btn" @click="backDocument" v-if="!is_edit">
                        <i class="fa fa-arrow-left mr-2 text-warning"></i>{{language_terms['BACK']}} 
                    </b-button>         
                    <b-button class="transparent-btn" @click="saveDocument" v-if="is_edit || is_edit_qty_sent || is_edit_qty_received">
                        <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}} 
                    </b-button>
                    <b-button class="transparent-btn" @click="cancelDocument" v-if="is_edit || is_edit_qty_sent || is_edit_qty_received">
                        <i class="fas fa-times mr-2 text-danger"></i>{{language_terms['CLOSE']}} 
                    </b-button>
                </b-button-group>
            </div>
        </div>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { mapState } from 'vuex';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Select, Option } from "element-ui";

import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';


import locationLookup from "@/components/Autocomplete.vue";
import productLookup from "@/components/Autocomplete.vue";
import moment from "moment";
import Vue from 'vue'

export default 
{
    components: {
        Loading,
        flatPicker,
        [Select.name]: Select,
        [Option.name]: Option,
        locationLookup,
        productLookup
    },
    data() {
        return{
            show_next_step:false,
            apiLocationLookup: apiRoutes["LOOKUP_WAREHOUSE"],
            apiProductLookup: apiRoutes["PRODUCT_LOOKUP_UNDER_LOCATION"],
            title:"",
            is_edit:false,
            is_edit_qty_sent:false,
            is_edit_qty_received:false,
            stocktransfer:{
                date_requested:"",
                code:"",
                from_location_id:"",
                from_location_code:"",
                from_location_name:"",
                to_location_id:"",
                to_location_code:"",
                to_location_name:"",
                remarks:"",
                items:[
                    {
                        sno:1,
                        product_id:"",
                        product_code:"",
                        product_name:"",
                        name:"",
                        qty_requested:"",
                        qty_sent:"",
                        qty_received:"",
                        from_location_available_qty:"",
                        to_location_available_qty:""
                    },
                    {
                        sno:2,
                        product_id:"",
                        product_code:"",
                        product_name:"",
                        name:"",
                        qty_requested:"",
                        qty_sent:"",
                        qty_received:"",
                        from_location_available_qty:"",
                        to_location_available_qty:""
                    },
                    {
                        sno:3,
                        product_id:"",
                        product_code:"",
                        product_name:"",
                        name:"",
                        qty_requested:"",
                        qty_sent:"",
                        qty_received:"",
                        from_location_available_qty:"",
                        to_location_available_qty:""
                    }
                ]
            }
        }
    },
    computed:{
        ...mapState({
            language_terms:(state) => state.languages.language_terms,
            is_created:(state) => state.stocktransfers.is_created,
            is_updated:(state) => state.stocktransfers.is_updated,
            is_provisioning: (state) => state.stocktransfers.is_provisioning,
            is_sent: (state) => state.stocktransfers.is_sent,
            is_received: (state) => state.stocktransfers.is_received,
            is_cancelled: (state) => state.stocktransfers.is_cancelled,
            stocktransfer_data: (state) => state.stocktransfers.data,
            stocktransfer_filter: (state) => state.stocktransfers.filter,
            to_warehouses: (state) => state.locations.to_warehouses,
            from_warehouses: (state) => state.locations.from_warehouses

        })
    },
    async mounted()
    {
        let document_id = this.$route.params.id;

        await this.$store.dispatch("locations/listFromWarehouses", {})
        await this.$store.dispatch("locations/listToWarehouses", {})

        if(document_id == '_new')
        {
            this.title = this.language_terms['NEW_TRANSFER_REQUEST']
            this.is_edit = true
            if(!this.stocktransfer.date_requested)
            {
                this.stocktransfer.date_requested = moment().format("YYYY-MM-DD");
            }
        }
        else
        {
            await this.$store.dispatch("stocktransfers/fetch", {code:document_id});

            if(this.stocktransfer_data)
            {
                this.stocktransfer = this.stocktransfer_data
                this.title = this.stocktransfer.code
            }
        }
    },
    methods:
    {
        onChangeQtySent(row, index)
        {
            
            if(row.qty_sent <= row.qty_requested)
            {
                let qty = row.qty_sent * 1

                let locations = row.locations
                console.log(locations)
                if(locations)
                {
                    let available_qty = 0;
                    for(let x = 0; x < locations.length; x++)
                    {
                        available_qty = available_qty + locations[x].qty;
                        if(locations[x].qty >= qty)
                        {
                            locations[x].allocate_qty =  qty
                        }
                        else
                        {
                            locations[x].allocate_qty = locations[x].qty
                        }

                        qty = qty - locations[x].allocate_qty

                    }
                }
                row.locations = locations
                this.$set(this.stocktransfer.items, index , row)
            }
        },
        async searchList()
        {
            this.isLoading = true
            let filter = {
                            keyword:"",
                            from_location_id:"",
                            to_location_id:"",
                            date_from:null,
                            date_to:null,
                            status:"PENDING"
                        }
            if(this.stocktransfer_filter)
            {
                filter = this.stocktransfer_filter
            }
            await this.$store.dispatch('stocktransfers/quickSearch', filter)

            this.isLoading = false
        },
        routeToMaster()
        {
            this.$router.push("/inventory/stocktransfers");
        }, 
        async confirmSent()
        {
            await this.$store.dispatch('stocktransfers/confirmSent', this.stocktransfer)

            if(this.is_sent)
            {
                await this.searchList()
                this.routeToMaster()
            }

        },
        async cancelTransfer()
        {
            await this.$store.dispatch('stocktransfers/cancelRequest', this.stocktransfer)

            if(this.is_cancelled)
            {
                await this.searchList()
                this.routeToMaster()
            }
        },
        backDocument()
        {
            this.routeToMaster()
        },
        cancelDocument()
        {
            let document_id = this.$route.params.id;
            if(document_id == '_new')
            {
                this.routeToMaster()
            }
            else
            {
                location.reload();
            }
        },
        async saveDocument()
        {
            if(this.$route.params.id == '_new')
            {
                await this.$store.dispatch("stocktransfers/create", this.stocktransfer);

                if(this.is_created)
                {
                    await this.searchList()
                    this.routeToMaster()
                }
            }
            else
            {
                if(this.stocktransfer.allow_edit_all && !this.is_edit_qty_sent)
                {
                    await this.$store.dispatch("stocktransfers/update", this.stocktransfer);
                    if(this.is_updated)
                    {
                        await this.searchList()
                        this.routeToMaster()
                    }
                }
                else if(this.stocktransfer.allow_provisioning && this.is_edit_qty_sent)
                {
                    await this.$store.dispatch("stocktransfers/provisioning", this.stocktransfer);

                    if(this.is_provisioning)
                    {
                        await this.searchList()
                        this.routeToMaster()
                    }
                }
                else if(this.stocktransfer.allow_edit_qty_received)
                {
                    await this.$store.dispatch("stocktransfers/comfirmReceived", this.stocktransfer);

                    if(this.is_received)
                    {
                        await this.searchList()
                        this.routeToMaster()
                    }
                }
            }
        },
        async provisionDocument()
        {
            
            if(this.stocktransfer.allow_provisioning)
            {
                this.is_edit_qty_sent = true
            }
            await this.$store.dispatch("stocktransfers/issueProvisioning", {id:this.stocktransfer.id});

            let items = this.stocktransfer_data.items

            for(let i = 0; i < items.length; i++)
            {
                items[i].qty_sent = items[i].qty_requested
                this.onChangeQtySent(items[i], i);
            }

            this.stocktransfer.items = items
        },
        editDocument()
        {
            if(this.stocktransfer.allow_edit_all)
            {
                this.is_edit = true
            }
            else if(this.stocktransfer.allow_provisioning)
            {
                this.is_edit_qty_sent = true
            }
            else if(this.stocktransfer.allow_edit_qty_received)
            {
                this.is_edit_qty_received = true
            }
        },
        handleDelete(index)
        {
            this.stocktransfer.items.splice(index, 1);
        },
        handleHide(index, row)
        {
            if(row.is_collasped)
            {
                row.is_collasped = false
            }
            else
            {
                row.is_collasped = true
            }

            this.$set(this.stocktransfer.items, index , row) 
        },
        handleCollaspe(index, row)
        {
            if(row.is_collasped)
            {
                row.is_collasped = false
            }
            else
            {
                row.is_collasped = true
            }

            this.$set(this.stocktransfer.items, index , row) 
        },
      addItems()
      {
          let sno = this.stocktransfer.items.length + 1
          this.stocktransfer.items.push(
              {
                sno:sno,
                product_id:"",
                product_code:"",
                product_name:"",
                name:"",
                qty_requested:"",
                qty_sent:"",
                qty_received:"",
                from_location_available_qty:"",
                to_location_available_qty:""
              }
          )
      },
      async getLocationQTY(product_id, from_location_id, to_location_id, index)
      {
        let pv = { from_location_id: from_location_id, to_location_id:to_location_id, product_id: product_id};
        await axios.post(apiRoutes["GET_PRODUCT_LOCATION_QTY"], pv, authHeader()).then((response) => 
        {
            if (response.data.code == 1) 
            {
                let data = response.data.data
                
                if(data)
                {
                    console.log(data)
                    this.stocktransfer.items[index].from_location_available_qty = data.from_location_available_qty
                    this.stocktransfer.items[index].to_location_available_qty = data.to_location_available_qty
                }
            } 
        })
        .catch((error) => 
        {
          if (error.response) 
          {
                Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
                });
          } 
          else 
          {
            console.log("Problem Querying Data", error);
          }
        });
      },
      resetItems()
      {
          this.stocktransfer.items = [
                    {
                        sno:1,
                        product_id:"",
                        product_code:"",
                        product_name:"",
                        name:"",
                        qty_requested:"",
                        qty_sent:"",
                        qty_received:"",
                        from_location_available_qty:"",
                        to_location_available_qty:""
                    },
                    {
                        sno:2,
                        product_id:"",
                        product_code:"",
                        product_name:"",
                        name:"",
                        qty_requested:"",
                        qty_sent:"",
                        qty_received:"",
                        from_location_available_qty:"",
                        to_location_available_qty:""
                    },
                    {
                        sno:3,
                        product_id:"",
                        product_code:"",
                        product_name:"",
                        name:"",
                        qty_requested:"",
                        qty_sent:"",
                        qty_received:"",
                        from_location_available_qty:"",
                        to_location_available_qty:""
                    }
                ]
      },
      goBack()
      {
          if(this.$route.params.id == '_new')
          {
            this.resetItems();
          } 
          this.show_next_step = false
      },
      fetchData()
      {

      },
      goNext()
      {
         if(this.stocktransfer.from_location_id && this.stocktransfer.to_location_id)
         {

            if(this.stocktransfer.from_location_id != this.stocktransfer.to_location_id)
            {
                this.show_next_step = true
            }

         }
         else
         {
            alert("Please select from location & to location!")
         }
      },
      async selectProduct(obj, index)
      {
          if(obj)
          {
              this.stocktransfer.items[index].product_id = obj.id
              this.stocktransfer.items[index].product_name = obj.name
              this.stocktransfer.items[index].name = obj.name

              this.stocktransfer.items[index].product_code = obj.code

              await this.getLocationQTY(obj.id, this.stocktransfer.from_location_id, this.stocktransfer.to_location_id, index)
          }
      },
      async selectToLocation(obj)
      {
          let location_id = null;
          let location_code = null;
          let location_name = null;

          if(obj)
          {
            location_id = obj.id
            location_code = obj.code
            location_name = obj.name
          }

          this.stocktransfer.to_location_id = location_id
          this.stocktransfer.to_location_code = location_code
          this.stocktransfer.to_location_name = location_name
      },
      async selectFromLocation(obj)
      {
          console.log(obj)
          let location_id = null;
          let location_code = null;
          let location_name = null;

          if(obj)
          {
            location_id = obj.id
            location_code = obj.code
            location_name = obj.name
          }

          this.stocktransfer.from_location_id = location_id
          this.stocktransfer.from_location_code = location_code
          this.stocktransfer.from_location_name = location_name
      },
    }

}
</script>
